import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './translations/en/common.json';
import arCommon from './translations/ar/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enCommon
      },
      ar: {
        translation: arCommon
      }
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    detection: {
      // Use localStorage first, then navigator language
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    },
    // Do not apply RTL - keep LTR for both languages as per requirements
    react: {
      useSuspense: false
    },
    ns: ['translation'],
    defaultNS: 'translation'
  });

export default i18n;